import axiosInstance from "./axiosInstance";

const HomeAPI = {
    getHomeData: async() => {
        const response = await axiosInstance.get("/front/pages/home-page");
        return response.data;
    },
    getAboutData: async() => {
        const response = await axiosInstance.get("/front/pages/about-us");
        return response.data;
    },
    getFaqsData: async() => {
        const response = await axiosInstance.get("/front/faqs");
        return response.data;
    },
    getServiceData: async() => {
        const response = await axiosInstance.get("/admin/Service");
        return response.data;
    },
    getBrandData: async() => {
        const response = await axiosInstance.get("/front/partenrs");
        return response.data;
    },
    getClientReviewData: async() => {
        const response = await axiosInstance.get("/front/ClientReview");
        return response.data;
    },
    getCategoryData: async() => {
        const response = await axiosInstance.get("/front/category");
        return response.data;
    },
    getCounrtyData: async() => {
        const response = await axiosInstance.get("/admin/counrty");
        return response.data;
    },
    gettermsData: async() => {
        const response = await axiosInstance.get("/front/pages/terms");
        return response.data;
    },
     getconditionData: async() => {
        const response = await axiosInstance.get("/front/pages/condition");
        return response.data;
    },
    getSettingData: async() => {
        const response = await axiosInstance.get("/front/setting");
        return response.data;
    },
    getNewsData: async() => {
        const response = await axiosInstance.get("/front/news?show_in_homepage=1");
        return response.data;
    },
    getOurServicesData: async() => {
        const response = await axiosInstance.get("/front/OurService?show_in_home_page=1");
        return response.data;
    },
    getOurService: async() => {
        const response = await axiosInstance.get("/front/OurService");
        return response.data;
    },
     getPageService: async() => {
        const response = await axiosInstance.get("/front/pages/services");
        return response.data;
    },
};

export default HomeAPI;